import { StateCreator } from "zustand";

interface INavigationState {
  lastSubrouteByCategory: Partial<Record<string, string>>;
}

interface INavigationActions {
  setLastSubroute: (categoryId: string, path: string) => void;
  resetNavigation: () => void;
}

export interface INavigationStore
  extends INavigationState,
    INavigationActions {}

export const createNavigationSlice: StateCreator<INavigationStore> = (set) => ({
  lastSubrouteByCategory: {},

  setLastSubroute: (categoryId, path) =>
    set((state) => ({
      lastSubrouteByCategory: {
        ...state.lastSubrouteByCategory,
        [categoryId]: path,
      },
    })),

  resetNavigation: () => set(() => ({ lastSubrouteByCategory: {} })),
});
